export const coordinatesToPostgisPoint = (longitude, latitude, srid = 4326) => {
    // Ensure longitude and latitude are valid numbers
    if (typeof longitude !== 'number' || typeof latitude !== 'number') {
        throw new Error('Invalid longitude or latitude values');
    }

    const view = new DataView(new ArrayBuffer(16));
    view.setFloat64(0, longitude, true); // little-endian
    view.setFloat64(8, latitude, true);

    // Convert the Uint8Array to a hexadecimal string
    let hexString = '';
    for (let i = 0; i < 16; i++) {
        hexString += view.getUint8(i).toString(16).padStart(2, '0').toUpperCase();
    }

    // Prepend the SRID value
    return `000000000${srid.toString(16).padStart(8, '0')}${hexString}`;

};

export const parseEWKBHex = (ewkbHex) => {
    if (!ewkbHex) return null;
    if (typeof ewkbHex === 'object') {
        if ('lng' in ewkbHex && 'lat' in ewkbHex) {
            return [ewkbHex.lng, ewkbHex.lat];
        }
    }

    // If input is an array
    if (Array.isArray(ewkbHex)) {
        return ewkbHex;
    }
    // Skip first 18 characters (SRID and geometry type info)
    const coordsHex = ewkbHex.substring(18);

    // Convert hex to Float64 coordinates
    const getFloat64 = (hex) => {
        const buffer = new ArrayBuffer(8);
        const view = new DataView(buffer);

        for (let i = 0; i < 8; i++) {
            view.setUint8(i, parseInt(hex.substring(i * 2, (i + 1) * 2), 16));
        }

        return view.getFloat64(0, true); // true for little-endian
    };

    const x = getFloat64(coordsHex.substring(0, 16));
    const y = getFloat64(coordsHex.substring(16, 32));

    return [x, y];
};
